module.exports = __webpack_public_path__ + "img/0-md.cd1a1ac3.jpg";